import './layout.css'
export default function PageHeader({ title, subtitle, actions, className = '', ...props }) {
    return <header {...props} className={'uiPageHeader ' + className}><div className="uiPageHeaderCopy"><h1>{title}</h1><p>{subtitle}</p></div>{actions && <div className="uiPageHeaderActions">{actions}</div>}</header>
}
